import { combineReducers } from 'redux';

import request from './request/requestReducer';
import systemStatus from './systemStatus/systemStatusReducer';

export default combineReducers({
	request,
	systemStatus,
});
